import React from 'react'
import { LuPlayCircle } from "react-icons/lu"
import useAppContext from '../../hook/useAppContext'
import './video.css'

const Video = () => {

      const {user} = useAppContext()
      const {videos} = user 

      if(videos.code) return 

      const video = `https://www.youtube.com/embed/${videos[0].id_video}?si=X71cnwxH5Ijkjeac`
      const title = videos[0].title 

      return (
            <div className="video_content">
                  <div className="video_content__box">
                        <iframe width="100%" height="100%" src={video} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                  </div>
                  <div className="video_content__title flex">
                        <LuPlayCircle />
                        <p>{title}</p>
                  </div>
            </div>
      )
}

export default Video
